<script context="module">
    window.process = { env: {NODE_ENF: 'production'}}
</script>

<script>
  import { onDestroy } from 'svelte';
  import { createPopperActions } from 'svelte-popperjs';
  const [popperRef, popperContent] = createPopperActions({
    placement: 'bottom-start',     
  });
  const extraOpts = {
    modifiers: [{ name: 'offset', options: { offset: [0, 5] } }],
  };

  export let index
  export let order
  export let type
  export let ignored  
  export let state
  export let move
  export let open = null
  export let max
  export let split
 
  let clean = true
  let number = order + 1

  function click(e) {
    console.log('part click', index, order, state)
    if (state) {
      if (state.restart) {
        move(index, order, 1)
        state.restart = false
        state.reorder = 1
        return
      }
      else if (state.reorder && order < state.reorder) {
        state = null
        return
      }
      else if (state.from || state.split) {
        state = null
        return
      }
      else if ((state.add || state.new) && index === state.index) {
        state = null
        return
      }
      
      move(index,order);
    } else {
     if (open && open.index === index && open.order === order) open = null
     else open = { index, order }
     if (clean) e.stopPropagation();
   }
  }

  onDestroy(() => {
    if (!clean) {      
      console.log('onDestroy')
      move(index, order, number)  
    }
  })
</script>

<span class="group" class:ignored 
  class:add={state?.add && index === state.index && order === state.order}
  class:heading={type === 'heading'}
  class:rubric={type === 'rubric'}
  use:popperRef on:mousedown={(e) => click(e)}
>
  <slot />
</span>

{#if open && open.index === index && open.order === order}
  <div use:popperContent={extraOpts} on:mousedown|stopPropagation={() => {}}>
    <span class="span">({index+1})</span>
    <input type="number" class="p-0 text-black" min="1" {max} bind:value={number} on:input={() => clean = false}>
    <input type="button" class="btn btn-green px-1 py-0.5" value="uspořádat" on:click|preventDefault={() => {state = {index, order: 0, reorder: -1, restart: true}; open = null}} />
    <select class="text-black w-18 p-0.5" bind:value={type}>
      <option value="fulltext">Text</option>
      <option value="heading">Nadpis</option>
      <option value="rubric">Rubrika</option>
    </select>    
    <input type="checkbox" class="mb-1.5" bind:checked={ignored} /> ignorovat
    <input type="button" class="btn btn-green px-1 py-0.5" value="od" on:click|preventDefault={() => {state = {index, order, from: true}; open = null}} />
    <input type="button" class="btn btn-green px-1 py-0.5" value="přidat" on:click|preventDefault={() => {state = {index, order, add: true}; open = null}} />
    <input type="button" class="btn btn-green px-1 py-0.5" value="rozdělit" on:click|preventDefault={() => {open = null; split(index,order)}} />
  </div>
{/if}


<style>
  .span {
    font-weight: bold;
    font-size: 1em;
  }

  .ignored {
    background-color: grey;
    /*float: left;
    z-index: 1;*/
  }

  .heading {
    border: 2px solid white;
  }

  .rubric {
    border: 2px solid red;
  }

  .add {
    background-color: brown;
  }

  div {
    background-color: blue;
    color: white;
    width: 17.5em;
    padding: 0.7em;
    padding-top: 0.6em;
    z-index: 3;
  }

  input[type="number"] {
    width: 3.3em;
    background-color:rgb(233, 233, 237);
    padding-left: 2px;
    padding-right: 1px;
  }

  input {
    margin-top: 5px;
  }

  select, input {
    appearance: auto;
    background-image: none;
  }
  
  select {
    background-color:rgb(233, 233, 237);
  }
</style>